import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, rsUrls } from "../../constants/ApiUrls";

export const getRSCategoryList = createAsyncThunk(
  "getRSCategoryList",
  async () => {
    try {
      const { data } = await axios.get(BASE_URL + rsUrls.GET_RS_CATEGORY_LIST);
      return data.payLoad;
    } catch (error) {
      return error.response;
    }
  }
);

export const addRSUsers = createAsyncThunk("addRSUsers", async (object) => {
  try {
    const { data } = await axios.post(BASE_URL + rsUrls.SAVE_RS_USER, object);
    return data.payLoad;
  } catch (error) {
    return error.response;
  }
});
